import { urls } from '../../../urls';

export const fetchLogoutTokenHandler = async (tokenHandler: string, clearStorageRefresh: React.Dispatch<void>) => {
    const authUrl = urls.AUTH;

    let body = {
        action: 'CLEAR_TOKEN',
    }
    const resp = await fetch(`${authUrl}/auth/${tokenHandler}`, {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: "include"
    })
    console.log('httpOnly resp: ', resp)
    if (resp.ok) {
        clearStorageRefresh()
    } else {
        console.log('Error logging out')
    }
}

